var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.hideList.includes(_vm.$route.path))?[(_vm.show)?_c('Hezuo'):_c('HezuoPC')]:_vm._e(),_vm._v(" "),_c('keep-alive',{attrs:{"exclude":"vedioDetil,mvediodteil,pc_move,pc_record,min_move,min_record,m_column_details,my_focus,my_collection,my_comments,m_my,m_index"}},[_c('router-view')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d94bc9b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 